import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var Svg48Play = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsxs("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 70 70"
  }, props), {}, {
    children: [/*#__PURE__*/jsxs("defs", {
      children: [/*#__PURE__*/jsxs("filter", {
        id: "48-play_svg__a",
        width: "179.5%",
        height: "179.5%",
        x: "-39.8%",
        y: "-39.8%",
        filterUnits: "objectBoundingBox",
        children: [/*#__PURE__*/jsx("feOffset", {
          dy: 3,
          "in": "SourceAlpha",
          result: "shadowOffsetOuter1"
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          "in": "shadowOffsetOuter1",
          result: "shadowBlurOuter1",
          stdDeviation: 3
        }), /*#__PURE__*/jsx("feColorMatrix", {
          "in": "shadowBlurOuter1",
          result: "shadowMatrixOuter1",
          values: "0 0 0 0 0.00392156863 0 0 0 0 0.0196078431 0 0 0 0 0.0196078431 0 0 0 0.06 0"
        }), /*#__PURE__*/jsxs("feMerge", {
          children: [/*#__PURE__*/jsx("feMergeNode", {
            "in": "shadowMatrixOuter1"
          }), /*#__PURE__*/jsx("feMergeNode", {
            "in": "SourceGraphic"
          })]
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: "48-play_svg__b",
        width: "121.7%",
        height: "117.9%",
        x: "-10.9%",
        y: "-8.9%",
        filterUnits: "objectBoundingBox",
        children: [/*#__PURE__*/jsx("feOffset", {
          "in": "SourceAlpha",
          result: "shadowOffsetOuter1"
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          "in": "shadowOffsetOuter1",
          result: "shadowBlurOuter1",
          stdDeviation: 0.5
        }), /*#__PURE__*/jsx("feColorMatrix", {
          "in": "shadowBlurOuter1",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        })]
      }), /*#__PURE__*/jsx("path", {
        id: "48-play_svg__c",
        d: "M30.62 21.341c.506.325.507.943.003 1.27l-6.196 4.02-5.528 3.586c-.663.43-1.652.052-1.654-.632l-.023-7.583-.022-7.583c-.002-.685.984-1.067 1.65-.639l5.55 3.566z"
      })]
    }), /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      filter: "url(#48-play_svg__a)",
      transform: "translate(13 13)",
      children: [/*#__PURE__*/jsx("circle", {
        cx: 22,
        cy: 22,
        r: 21.313,
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.38,
        stroke: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        strokeWidth: 1.375
      }), /*#__PURE__*/jsx("use", {
        xlinkHref: "#48-play_svg__c",
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey800,
        filter: "url(#48-play_svg__b)"
      }), /*#__PURE__*/jsx("use", {
        xlinkHref: "#48-play_svg__c",
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      })]
    })]
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg48Play$1 = Svg48Play;

export { Svg48Play$1 as default };
